/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosRequestConfig } from 'axios';
import { axios } from '../axios.config';

interface VoucherPatchRequest {
  isPassed?: string;
  examPassFailDate?: string;
  email?: string;
  isCanceled?: boolean;
  activatedDate?: string;
  expireDate?: string;
  originalExpireDate?: string;
  orderId?: string;
  productId?: string;
  memberId?: string;
  orgId?: string;
  voucherCode?: string;
  drawingStatus?: string;
  applicationStatus?: string;
  submittedDate?: string;
  approvedDate?: string;
  badgePackageFullfilled?: boolean;
  cancelledReason?: string;
  cancelledReasonNote?: string;
  certificationPackageSentDate?: string;
}

export class VoucherApiResource {
  /**
   * Update an existing voucher
   *
   * @param userId User id
   * @param body
   */
  public updateVoucher(voucherId: string, body?: VoucherPatchRequest, axiosConfig?: AxiosRequestConfig): Promise<{}> {
    const reqPath = `/v1/voucher/${voucherId}`;
    let reqConfig = {
      ...axiosConfig,
      method: 'PATCH',
      url: reqPath,
      data: body,
    };
    return axios.request(reqConfig).then(res => {
      return res.data;
    });
  }
  public getVouchersByMember(memberId: string, tagType: string, body?: VoucherPatchRequest, axiosConfig?: AxiosRequestConfig): Promise<{}> {
    const reqPath = `/v1/voucher/getVouchersByMember/${memberId}/${tagType}`;
    let reqConfig = {
      ...axiosConfig,
      method: 'GET',
      url: reqPath,
      data: body,
    };

    return axios.request(reqConfig).then(res => res.data);
  }
  public reassignVoucher(voucherId: string, body?: VoucherPatchRequest, axiosConfig?: AxiosRequestConfig): Promise<{}> {
    const reqPath = `/v1/voucher/${voucherId}/retake`;
    let reqConfig = {
      ...axiosConfig,
      method: 'POST',
      url: reqPath,
      data: body,
    };
    return axios.request(reqConfig).then(res => {
      return res.data;
    });
  }
  public extendEligibility(memberId: string, body?: VoucherPatchRequest, axiosConfig?: AxiosRequestConfig): Promise<{}> {
    const reqPath = `/v1/voucher/extend/${memberId}`;
    let reqConfig = {
      ...axiosConfig,
      method: 'POST',
      url: reqPath,
      data: body,
    };
    return axios.request(reqConfig).then(res => {
      return res.data;
    });
  }
  public createVoucher(memberId: string, body?: VoucherPatchRequest, axiosConfig?: AxiosRequestConfig): Promise<{}> {
    const reqPath = `/v1/voucher/${memberId}`;
    let reqConfig = {
      ...axiosConfig,
      method: 'POST',
      url: reqPath,
      data: body,
    };
    return axios.request(reqConfig).then(res => {
      return res.data;
    });
  }
  public deleteVoucher(voucherId: string, body?: VoucherPatchRequest, axiosConfig?: AxiosRequestConfig): Promise<{}> {
    const reqPath = `/v1/voucher/${voucherId}`;
    let reqConfig = {
      ...axiosConfig,
      method: 'DELETE',
      url: reqPath,
      data: body,
    };
    return axios.request(reqConfig).then(res => {
      return res.data;
    });
  }
  public cancelVoucher(voucherId: string, axiosConfig?: AxiosRequestConfig): Promise<{}> {
    const reqPath = `/v1/voucher/cancel/${voucherId}`;
    let reqConfig = {
      ...axiosConfig,
      method: 'DELETE',
      url: reqPath
    };
    return axios.request(reqConfig).then(res => {
      return res.data;
    });
  }
  public resendemail(memberId: string, productType: string, axiosConfig?: AxiosRequestConfig): Promise<{}> {
    const reqPath = `/v1/voucher/resendemail/${memberId}/${productType}`;
    let reqConfig = {
      ...axiosConfig,
      method: 'POST',
      url: reqPath
    };
    return axios.request(reqConfig).then(res => {
      return res.data;
    });
  }
  public resendwelcomeemail(voucherId: string, axiosConfig?: AxiosRequestConfig): Promise<{}> {
    const reqPath = `/v1/voucher/resendwelcomeemail/${voucherId}`;
    let reqConfig = {
      ...axiosConfig,
      method: 'POST',
      url: reqPath
    };
    return axios.request(reqConfig).then(res => {
      return res.data;
    });
  }
}

// getCertificationExamsByMember



export const VoucherApi = new VoucherApiResource();



// WEBPACK FOOTER //
// ./src/common/api/resources/Voucher.ts